import React from 'react';
import numeral from 'numeral';
import { makeStyles, Chip } from '@material-ui/core';
import { green, red, orange, blue } from '@material-ui/core/colors';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import AllInclusive from '@material-ui/icons/AllInclusive';
import {
  AllInbox,
  History,
  NotificationsActiveOutlined,
  QuestionAnswerOutlined
} from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  check: {
    color: green[500]
  },
  times: {
    color: red[500]
  },
  chip: {
    background: orange[300],
    color: '#fff'
  },
  infinite: {
    color: blue[500]
  }
}));

const Check = () => {
  const classes = useStyles();
  return <CheckIcon className={classes.check} />;
};

const Times = () => {
  const classes = useStyles();
  return <CloseIcon className={classes.times} />;
};
const Infinite = () => {
  const classes = useStyles();
  return <AllInclusive className={classes.infinite} />;
};

const generalFeatures = [
  {
    featureDescription: 'Tax Compliance',
    ulapTaxNonVat: <Check />,
    ulapTaxVat: <Check />,
    ulapBizPro: <Check />,
    ulapBizEnt: <Check />
  },
  {
    featureDescription: 'Tax Attachments',
    ulapTaxNonVat: <Check />,
    ulapTaxVat: <Check />,
    ulapBizPro: <Check />,
    ulapBizEnt: <Check />
  },

  {
    featureDescription: 'Financial Reports',
    ulapTaxNonVat: <Times />,
    ulapTaxVat: <Times />,
    ulapBizPro: <Check />,
    ulapBizEnt: <Check />
  },
  {
    featureDescription: 'Other Customizable Reports',
    ulapTaxNonVat: <Times />,
    ulapTaxVat: <Times />,
    ulapBizPro: <Check />,
    ulapBizEnt: <Check />
  },
  {
    featureDescription: 'Fully Automated Accounting System',
    ulapTaxNonVat: <Times />,
    ulapTaxVat: <Times />,
    ulapBizPro: <Times />,
    ulapBizEnt: <Check />
  }
];

const features = [
  {
    featureDescription: 'Encoder User Access',
    ulapTaxNonVat: 1,
    ulapTaxVat: 1,
    ulapBizPro: 3,
    ulapBizEnt: <Check />
  },
  {
    featureDescription: 'Agent Viewing Access',
    ulapTaxNonVat: 1,
    ulapTaxVat: 1,
    ulapBizPro: 1,
    ulapBizEnt: <Check />
  },
  {
    featureDescription: 'GL Accounts',
    ulapTaxNonVat: 10,
    ulapTaxVat: 20,
    ulapBizPro: 50,
    ulapBizEnt: <Infinite />,
    parent: true
  },
  {
    featureDescription: 'Require Balance Feature (2 Accounts)',
    ulapTaxNonVat: <Times />,
    ulapTaxVat: <Times />,
    ulapBizPro: <Check />,
    ulapBizEnt: <Check />,
    indent: 1
  },
  {
    featureDescription: 'GL Sub-Account Types',
    ulapTaxNonVat: 3,
    ulapTaxVat: 4,
    ulapBizPro: 10,
    ulapBizEnt: <Infinite />,
    parent: true
  },
  {
    featureDescription: 'Supplier',
    ulapTaxNonVat: <Check />,
    ulapTaxVat: <Check />,
    ulapBizPro: <Check />,
    ulapBizEnt: <Check />,
    indent: 1
  },
  {
    featureDescription: 'Customer',
    ulapTaxNonVat: <Check />,
    ulapTaxVat: <Check />,
    ulapBizPro: <Check />,
    ulapBizEnt: <Check />,
    indent: 1
  },
  {
    featureDescription: 'Expenses',
    ulapTaxNonVat: <Check />,
    ulapTaxVat: <Check />,
    ulapBizPro: <Check />,
    ulapBizEnt: <Check />,
    indent: 1
  },
  {
    featureDescription: 'Customizeable',
    ulapTaxNonVat: <Times />,
    ulapTaxVat: <Check />,
    ulapBizPro: <Check />,
    ulapBizEnt: <Check />,
    indent: 1
  },
  {
    featureDescription: 'SL Accounts',
    ulapTaxNonVat: '20',
    ulapTaxVat: '1000',
    ulapBizPro: '1000',
    ulapBizEnt: <Infinite />
  },
  {
    featureDescription: 'Transaction Types',
    ulapTaxNonVat: '4',
    ulapTaxVat: '4',
    ulapBizPro: '10',
    ulapBizEnt: <Infinite />
  },

  {
    featureDescription: 'Vouchering System',
    ulapTaxNonVat: '',
    ulapTaxVat: '',
    ulapBizPro: '',
    ulapBizEnt: '',
    parent: true
  },
  {
    featureDescription: 'Digital Attachment (5/transaction)',
    ulapTaxNonVat: <Times />,
    ulapTaxVat: <Times />,
    ulapBizPro: <Check />,
    ulapBizEnt: <Check />,
    indent: 1
  },
  {
    featureDescription: 'QR Code Links',
    ulapTaxNonVat: <Times />,
    ulapTaxVat: <Times />,
    ulapBizPro: <Check />,
    ulapBizEnt: <Check />,
    indent: 1
  },
  {
    featureDescription: 'Check Printer',
    ulapTaxNonVat: <Times />,
    ulapTaxVat: <Times />,
    ulapBizPro: <Check />,
    ulapBizEnt: <Check />,
    indent: 1
  },
  {
    featureDescription: 'Voucher Printing',
    ulapTaxNonVat: <Times />,
    ulapTaxVat: <Times />,
    ulapBizPro: <Check />,
    ulapBizEnt: <Check />,
    indent: 1
  },
  {
    featureDescription: 'Transactions per Day',
    ulapTaxNonVat: 40,
    ulapTaxVat: 80,
    ulapBizPro: 300,
    ulapBizEnt: <Infinite />
  },
  {
    featureDescription: 'Inventory',
    ulapTaxNonVat: '',
    ulapTaxVat: '',
    ulapBizPro: '',
    ulapBizEnt: '',
    parent: true
  },
  {
    featureDescription: 'Inventory Warehouse',
    ulapTaxNonVat: <Times />,
    ulapTaxVat: <Times />,
    ulapBizPro: '1',
    ulapBizEnt: <Check />,
    indent: 2
  },
  {
    featureDescription: 'Stock Cards',
    ulapTaxNonVat: <Times />,
    ulapTaxVat: <Times />,
    ulapBizPro: <Check />,
    ulapBizEnt: <Check />,
    indent: 2
  },
  {
    featureDescription: 'Purchase Order',
    ulapTaxNonVat: <Times />,
    ulapTaxVat: <Times />,
    ulapBizPro: <Times />,
    ulapBizEnt: <Check />,
    indent: 2
  },
  {
    featureDescription: 'Sales Order',
    ulapTaxNonVat: <Times />,
    ulapTaxVat: <Times />,
    ulapBizPro: <Times />,
    ulapBizEnt: <Check />,
    indent: 2
  },
  {
    featureDescription: 'Stock Transfers',
    ulapTaxNonVat: <Times />,
    ulapTaxVat: <Times />,
    ulapBizPro: <Check />,
    ulapBizEnt: <Check />,
    indent: 2
  },
  {
    featureDescription: 'Ending Inventory Report',
    ulapTaxNonVat: <Times />,
    ulapTaxVat: <Times />,
    ulapBizPro: <Check />,
    ulapBizEnt: <Check />,
    indent: 2
  },
  {
    featureDescription: 'Sales Report',
    ulapTaxNonVat: <Times />,
    ulapTaxVat: <Times />,
    ulapBizPro: <Check />,
    ulapBizEnt: <Check />,
    indent: 2
  },
  {
    featureDescription: 'Purchases Report',
    ulapTaxNonVat: <Times />,
    ulapTaxVat: <Times />,
    ulapBizPro: <Check />,
    ulapBizEnt: <Check />,
    indent: 2
  },
  {
    featureDescription: 'Reports',
    ulapTaxNonVat: '',
    ulapTaxVat: '',
    ulapBizPro: '',
    ulapBizEnt: '',
    parent: true
  },
  {
    featureDescription: 'GL SL Report',
    ulapTaxNonVat: <Check />,
    ulapTaxVat: <Check />,
    ulapBizPro: <Check />,
    ulapBizEnt: <Check />,
    indent: 1
  },
  {
    featureDescription: 'SLSP, QAP,SAWT',
    ulapTaxNonVat: <Times />,
    ulapTaxVat: <Check />,
    ulapBizPro: <Check />,
    ulapBizEnt: <Check />,
    indent: 1
  },
  {
    featureDescription: 'Trial Balance',
    ulapTaxNonVat: <Check />,
    ulapTaxVat: <Check />,
    ulapBizPro: <Check />,
    ulapBizEnt: <Check />,
    indent: 1
  },
  {
    featureDescription: 'Balance Sheet',
    ulapTaxNonVat: <Times />,
    ulapTaxVat: <Times />,
    ulapBizPro: <Check />,
    ulapBizEnt: <Check />,
    indent: 1
  },
  {
    featureDescription: 'Income Statement',
    ulapTaxNonVat: <Times />,
    ulapTaxVat: <Times />,
    ulapBizPro: <Check />,
    ulapBizEnt: <Check />,
    indent: 1
  },
  {
    featureDescription: 'Cash Flow Statement',
    ulapTaxNonVat: <Times />,
    ulapTaxVat: <Times />,
    ulapBizPro: <Check />,
    ulapBizEnt: <Check />,
    indent: 1
  },
  {
    featureDescription: 'Changes in Equity Statement',
    ulapTaxNonVat: <Times />,
    ulapTaxVat: <Times />,
    ulapBizPro: <Check />,
    ulapBizEnt: <Check />,
    indent: 1
  },
  {
    featureDescription: '3 Special Reports',
    ulapTaxNonVat: <Times />,
    ulapTaxVat: <Times />,
    ulapBizPro: <Check />,
    ulapBizEnt: <Check />,
    indent: 1
  },
  {
    no: '11',
    featureDescription: 'Management Worktool',
    ulapTaxNonVat: '',
    ulapTaxVat: '',
    ulapBizPro: '',
    ulapBizEnt: '',
    parent: true
  },
  {
    featureDescription: 'DaloyWF',
    ulapTaxNonVat: <Times />,
    ulapTaxVat: <Times />,
    ulapBizPro: '1',
    ulapBizEnt: <Infinite />,
    indent: 1
  },
  {
    featureDescription: 'Standard Dashboard',
    ulapTaxNonVat: <Times />,
    ulapTaxVat: <Times />,
    ulapBizPro: <Check />,
    ulapBizEnt: <Check />,
    indent: 1
  },
  {
    featureDescription: 'Custom Dashboards',
    ulapTaxNonVat: <Times />,
    ulapTaxVat: <Times />,
    ulapBizPro: <Times />,
    ulapBizEnt: <Check />,
    indent: 1
  },
  {
    featureDescription: 'Action Requests (Notifiers)',
    ulapTaxNonVat: <Times />,
    ulapTaxVat: <Times />,
    ulapBizPro: <Check />,
    ulapBizEnt: <Check />,
    indent: 1
  },
  {
    featureDescription: 'Billable add-ons',
    ulapTaxNonVat: '',
    ulapTaxVat: '',
    ulapBizPro: '',
    ulapBizEnt: '',
    parent: true
  },
  {
    featureDescription: 'Plus Access/User',
    ulapTaxNonVat: <div>&#8369; 1000</div>,
    ulapTaxVat: <div>&#8369; 1000</div>,
    ulapBizPro: <div>&#8369; 1000</div>,
    ulapBizEnt: <Check />,
    indent: 1
  },
  {
    featureDescription: 'Branch (for every 10 branches)',
    ulapTaxNonVat: <Times />,
    ulapTaxVat: <Times />,
    ulapBizPro: <div>&#8369; 1000</div>,
    ulapBizEnt: <Check />,
    indent: 1
  },
  {
    featureDescription: 'Plus Warehouse',
    ulapTaxNonVat: <Times />,
    ulapTaxVat: <Times />,
    ulapBizPro: <div>&#8369; 1000</div>,
    ulapBizEnt: <Check />,
    indent: 1
  },
  {
    featureDescription: 'Plus GL Accounts',
    ulapTaxNonVat: <Times />,
    ulapTaxVat: <Times />,
    ulapBizPro: <div>&#8369; 1000</div>,
    ulapBizEnt: <Check />,
    indent: 1
  },
  {
    featureDescription: 'Plus Special Report: One Time Payment',
    ulapTaxNonVat: <Times />,
    ulapTaxVat: <Times />,
    ulapBizPro: <div>&#8369; 5000</div>,
    ulapBizEnt: <Check />,
    indent: 1
  },
  {
    featureDescription: 'Plus GL Accounts (50 Accounts)',
    ulapTaxNonVat: <Times />,
    ulapTaxVat: <Times />,
    ulapBizPro: <div>&#8369; 1000</div>,
    ulapBizEnt: <Check />,
    indent: 1
  },
  {
    featureDescription: 'Plus Digital Attachments (per Transaction Type)',
    ulapTaxNonVat: <Times />,
    ulapTaxVat: <Times />,
    ulapBizPro: <div>&#8369; 1000</div>,
    ulapBizEnt: <Check />,
    indent: 1
  }
];

const pricing = {
  ulapTaxNonVat: {
    basic: numeral(1000).format('#,###.##'),
    vat: numeral(120).format('#,###.##'),
    grandTotal: numeral(1120).format('#,###.##')
  },
  ulapTaxVat: {
    basic: numeral(3000).format('#,###.##'),
    vat: numeral(360).format('#,###.##'),
    grandTotal: numeral(3360).format('#,###.##')
  },
  ulapBizPro: {
    basic: numeral(6000).format('#,###.##'),
    vat: numeral(720).format('#,###.##'),
    grandTotal: numeral(6720).format('#,###.##')
  },
  ulapBizEnt: { basic: '', vat: '', grandTotal: 'Contract Based' }
};

const reports = [
  {
    title: 'General Ledger',
    description:
      'Summarizes all the transactions during a period which encompass data needed to produce the entity’s financial statements.  In addition, it includes information about each transaction such as date, amount and some descriptive  information regarding the transaction.'
  },
  {
    title: 'Subsidiary Ledger',
    description:
      'A generated report that shows and stores the details of a general ledger control account. It shows the transaction and payment history of each customer or supplier.'
  },
  {
    title: 'Cash Position Report',
    description:
      'A report that shows and summarizes the movement of cash and cash equivalents of a certain company especially with banking institutions at any given point in time.'
  },
  {
    title: 'Revenue/Sales Report',
    description:
      'Summarizes the revenue/sales activities of the business which include information such as customer’s profile, sales invoice number and date, and products together with their corresponding price and quantity.'
  },
  {
    title: 'Receivable Report',
    description:
      'A report that contains the outstanding balances of the customers to the entity for a certain period of time. It also shows how much is due from customers and those that are late in payments.'
  },
  {
    title: 'Expenses Report',
    description:
      'Contains a categorized list of expenses which reflects the entity’s expenditures during a period. It is used to track the business spending and includes the date, amount, and brief description of each expense.'
  },
  {
    title: 'Payable Report',
    description:
      'A report that summarizes all the balances owed to suppliers and other creditors. It includes supplier and creditor’s name, amount, due date and whether any payments are past due.'
  },
  {
    title: 'Inventory Report',
    description:
      'A report that shows the flow and status of existing inventories of a company at a given time detailing its value, status, and availability from stock-in to stock-out. It allows the manager to determine discrepancies between the allocated stocks and available stocks on hand.'
  },
  {
    title: 'Trial Balance',
    description:
      'A report that shows the balances of all main accounting elements such as assets, liabilities, equity, revenues, and expenses at a specific point in time.'
  },
  {
    title: 'Balance Sheet',
    description:
      'Displays the financial position of the business for a given point in time usually at the end of the quarter or year, outlining a rundown of assets, liabilities, and shareholder’s equity.'
  },
  {
    title: 'Income Statement',
    description:
      "A financial statement that shows the financial performance of the entity. It contains the entity's revenues, expenses and the overall profit/loss for a specific period of time."
  },
  {
    title: 'Cash Flow Statement',
    description:
      'A financial statement that provides comprehensive data regarding all cash inflows and cash outflows during a reporting period. It includes cash flows from operating activities, investing activities and financing activities.'
  },
  {
    title: 'Changes in Equity Statement',
    description:
      'It reports the changes in a company’s capital balance over a period of time. It usually comprises three components namely net income, retained earnings and share capital.'
  },
  {
    title: 'Business Tax and Attachments',
    description:
      'Reports including Summary Alphalist of Sales and Purchases (SLSP), Summary Alphalist of Withholding Taxes (SAWT), Quarterly Alphalist of Payees (QAP) and other necessary attachments filed to BIR  that are auto-generated in a convenient way.  '
  },
  {
    title: 'Other Customizeable Reports',
    description:
      'These are reports other than the aforementioned reports. These can be prepared on the client’s request and requirements that cater their specific needs. '
  }
];

const Content = ({ question, answer }) => {
  return (
    <>
      <span style={{ fontWeight: 900, fontSize: '1rem', display: 'block' }}>
        {question}
      </span>

      <span style={{ display: 'block', marginTop: '.5em' }}>{answer}</span>
    </>
  );
};

const notable_features = [
  {
    key: 'advance-stock-card',
    title: 'Advanced Stock Card',
    description: (
      <Content
        question="Having a hard time keeping track of your inventory?"
        answer="The system can now display your stock card in a comprehensive and
    graphical way so you can manage and locate your stocks real-time."
      />
    ),
    iconSoure: 'mui',
    Icon: AllInbox
  },
  {
    key: 'customizable-reports',
    title: 'Customizable Reports',
    description: (
      <Content
        question="Need more information than the standard reports can offer?"
        answer="The system is geared to assisting businessmen in producing reports based on their
        specific demands and requirements."
      />
    ),
    iconSoure: 'fa',
    Icon: 'faFileContract'
  },
  {
    key: 'workflows-and-dashboard',
    title: 'Workflows and Dashboard',
    description: (
      <Content
        question="Experiencing job delays due to unorganized segregation of duties?"
        answer="With the integrated workflows and dashboard, process flows are now automated
        and capable of handling irregularities.
        "
      />
    ),
    iconSoure: 'fa',
    Icon: 'faCodeCompare'
  },
  {
    key: 'exportable-and-printable-BIR',
    title: 'Exportable & Printable BIR Requirements',
    description: (
      <Content
        question="Getting tired with all the hassle of filing tax obligations?"
        answer="The system is equipped to provide BIR requirements including printable BIR Forms
        and exportable DAT files, which are beneficial for fulfilling legal requirements.        
        "
      />
    ),
    iconSoure: 'fa',
    Icon: 'faPercent'
  },
  {
    key: 'logs',
    title: 'Audit Logs',
    description: (
      <Content
        question="Coming up against the difficulty of finding who’s accountable with your records?"
        answer="The system integrates automated logs that records all changes that occurred inside
        the transactions."
      />
    ),
    iconSoure: 'mui',
    Icon: History
  }
];

const interactive_features = [
  {
    key: 'attachments-and-comments-and-checklist',
    title: 'Attachments, Comments and Checklist',
    description: (
      <Content
        question="Hoping you could file your documents better or concerns could be addressed sooner?"
        answer="Share your thoughts and upload any required attachment to communicate all
        information on the transaction itself."
      />
    ),
    iconSoure: 'mui',
    Icon: QuestionAnswerOutlined
  },
  {
    key: 'sms-email-notifications',
    title: 'SMS/Email Notifications',
    description: (
      <Content
        question="Not wanting to miss any important update on your transactions?"
        answer="Get automated notifications thru SMS or e-mail every day without having to do
        anything."
      />
    ),
    iconSoure: 'mui',
    Icon: NotificationsActiveOutlined
  },
  {
    key: 'remote-transactions',
    title: 'Remote Transactions',
    description: (
      <Content
        question="Worrying about causing unnecessary delays due to absence at work?"
        answer="Since the system is cloud-based, you can now review and/or approve transactions in
        any device as long you have internet connection."
      />
    ),
    iconSoure: 'fa',
    Icon: 'faLaptopFile'
  },
  {
    key: 'collaboration-and-documentation-tools',
    title: 'Collaboration and Documentation Tools',
    description: (
      <Content
        question="Want to lessen complications due to miscommunications?"
        answer="With job assignment and prioritization tools being integrated in the system,
    everyone’s specific tasks can be managed and monitored better."
      />
    ),
    iconSoure: 'fa',
    Icon: 'faUsers'
  },
  {
    key: 'qr-code',
    title: 'QR Code',
    description: (
      <Content
        question="Finding a way to get rid of the countless printed documents being piled up on your
        desk?"
        answer="Checking the transactions in the system are made easy thru the integration of QR
        codes that you may scan to be able to access the transaction directly."
      />
    ),
    iconSoure: 'fa',
    Icon: 'faQrcode'
  }
];

export const solutions_database = [
  {
    key: 'construction',
    image: '/static/images/landing-page/sample.png',
    title: 'Construction',
    description:
      "Ulap.Biz is worth much more than I paid. I would also like to say thank you to all your staff. If you aren't sure, always go for Ulap.Biz."
  },
  {
    key: 'trading',
    image: '/static/images/landing-page/logo.png',
    title: 'Trading',
    description:
      "Ulap.Biz has really helped our business. It's the perfect solution for our business. Ulap.Biz is the most valuable business resource we have EVER purchased. It fits our needs perfectly."
  },
  {
    key: 'logistics',
    image: '/static/images/landing-page/sample2.png',
    title: 'Logistics',
    description:
      "Thanks Ulap.Biz! I love your system. We were treated like royalty. I can't say enough about Ulap.Biz."
  }
];

export default {
  features,
  reports,
  notable_features,
  interactive_features,
  pricing,
  generalFeatures
};
